import { render, staticRenderFns } from "./draw.vue?vue&type=template&id=7671ff2b&scoped=true"
import script from "./draw.vue?vue&type=script&lang=js"
export * from "./draw.vue?vue&type=script&lang=js"
import style0 from "./draw.vue?vue&type=style&index=0&id=7671ff2b&prod&scoped=true&lang=css"
import style1 from "./draw.vue?vue&type=style&index=1&id=7671ff2b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7671ff2b",
  null
  
)

export default component.exports